import { render, staticRenderFns } from "./map-debug-menu.vue?vue&type=template&id=3b974bc2&scoped=true"
import script from "./map-debug-menu.vue?vue&type=script&lang=js"
export * from "./map-debug-menu.vue?vue&type=script&lang=js"
import style0 from "./map-debug-menu.vue?vue&type=style&index=0&id=3b974bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b974bc2",
  null
  
)

export default component.exports